(function (_) {
    'use strict';

    _['POINTS.KEY'] = 'Programa de puntos';
    _['POINTS.EMPTY-LIST'] = 'No hay programas de puntos activos en este momento.';
    _['POINTS.VALID-FROM'] = 'Desde: ';
    _['POINTS.VALID-UNTIL'] = 'Hasta: ';
    _['POINTS.NO-LIMIT'] = 'Sin límite';
    _['POINTS.CONDITIONS'] = 'Condiciones';
    _['POINTS.CANCEL'] = 'Cancelar';
    _['POINTS.ACCEPT'] = 'Aceptar';
    _['POINTS.ASSIGN'] = 'Recibir puntos';
    _['POINTS.REDEEM'] = 'Canjear puntos';
    _['POINTS.EXCEPTIONS-TITLE'] = 'Excepciones';
    _['POINTS.PERIOD-VALIDITY'] = 'Periodo de validez';
    _['POINTS.DAILY-LIMIT'] = 'Has superado el límite diario.';
    _['POINTS.VALID-CODE'] = 'Código válido';
    _['POINTS.INVALID-CODE'] = 'Código inválido';
    _['POINTS.PRIZE.WON'] = '¡Premio canjeado correctamente!';
    _['POINTS.ASSIGN.COMPLETE'] = '¡Puntos asignados correctamente!';
    _['POINTS.CODE-SHOW'] = 'Mostrar el QR para recibir puntos';
    _['POINTS.CODE-REDEEM'] = 'Mostrar el QR para canjear el premio:';
    _['POINTS.POINTS-NOW'] = 'Total de puntos: ';
    _['POINTS.POINTS-EARNED'] = 'Puntos recibidos:';
    _['POINTS.POINTS.POINTS'] = 'Puntos';

}(translations['es']));



// WEBPACK FOOTER //
// ./src/app/modules/points/lang/points-lang_es.js